
  import React,{Component} from "react";
  import "leaflet/dist/leaflet.css";
  import L from "leaflet";
  import "leaflet-side-by-side";
  
  
  import colors from "../../colors";
  import "./Compare.css";
  import {
    Button,
   
    Menu,
  } from "semantic-ui-react";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
 


  
  
  class LeafletCompare extends Component {
    constructor(props) {
      super(props);
      this.mapRef = React.createRef(); // Creating a ref

      this.map = null;
      this.sideBySideControl = null;
      this.osmLayer = null;
      this.open=null;
      this.satelliteLayer = null;
      this.state={
        legendVisible: true,
        legendleft:null,
        legendright:null,
        indiamapcenter: window.innerWidth>1000?[23.12539, 79.00164]:[20.13,80.58],
        minZoom: 3,
        maxZoom: 15,
        crs: L.CRS.EPSG4326,

        zoom: window.innerWidth>1000?5:4,
        selectedLayer: "osm", // Initially selected layer is OSM
        baselayers:true,

       
      }

    }

  
    componentDidMount() {
      this.initializeMap();
      this.addPanelTitles();
      this.getLegendGraphic1();
      this.getLegendGraphic2();

    }
    
 handlebaselayerchange=()=>
 {
  this.setState({
    baselayers:!this.state.baselayers

  })
 }

  
    componentDidUpdate(prevProps) {

        let layer,layer_type;
        //let legendleft,legendright;
        if (
          prevProps.productselected !== this.props.productselected ||
          prevProps.productselectedR !== this.props.productselectedR ||



          prevProps.timestampselected !== this.props.timestampselected ||
          prevProps.compare_fn_selectedMonth !== this.props.compare_fn_selectedMonth ||
          prevProps.compare_fn_selectedFN !== this.props.compare_fn_selectedFN ||
          prevProps.compare_fn_selectedYear !== this.props.compare_fn_selectedYear ||
          prevProps.timestampselectedR !== this.props.timestampselectedR ||
          prevProps.compare_mn_selectedMonthR !== this.props.compare_mn_selectedMonthR ||
          prevProps.compare_mn_selectedYearR !== this.props.compare_mn_selectedYearR ||
         
          prevProps.compare_fn_selectedMonthR !== this.props.compare_fn_selectedMonthR ||
          prevProps.compare_fn_selectedFNR !== this.props.compare_fn_selectedFNR ||
          prevProps.compare_fn_selectedYearR !== this.props.compare_fn_selectedYearR ||
          prevProps.compare_mn_selectedMonth !== this.props.compare_mn_selectedMonth ||
          prevProps.compare_mn_selectedYear !== this.props.compare_mn_selectedYear 


      ) {
          this.addPanelTitles();
          this.getLegendGraphic1();
          this.getLegendGraphic2();
      }
      

      if(this.props.productselected.split(" ")[0].toLowerCase()==="et" || this.props.productselected.split(" ")[0].toLowerCase()==="pet" || this.props.productselected.split(" ")[0].toLowerCase()==="mai" || this.props.productselected.split(" ")[0].toLowerCase()==="esi"  )
   {   

      const colors_range_etleft = [
        "#ffffa0","#ffff78","#c0f766","#84ed48","#47de31","#58b660","#3cab80","#2595a9","#26659a","#203a77","#00ffff","#f6ffff","#c0c0c0"
        // "#d6e4ff","#adc6ff","#85a5ff","#597ef7","#2f54eb","#2949cc","#1d39c4","#1d39c4","#10239e","#061178","#030852","#f0f5ff","#c7d1e6"
      ];
      const grades_etleft= [
        // "0 - 1",
        // "1 - 2",
        // "2 - 3",
        // "3 - 4",
        // " 4 - 5",
        // "5 - 6",
        // "6 - 7",
        // " 7 - 8",
        // "8 - 9",
        // "9 - 10",
        // "10",
        // "Cloud",
        // "No Data",
        "0.0-0.5","0.5-1.0","1.0-1.5","1.5-2.0","2.0-2.5","2.5-3.0","3.0-3.5","3.5-4.0","4.0-4.5","4.5-5.0",">5.0","Cloud","No Data"
      ];

      let imgleft = grades_etleft.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i key={key} style={{ background: `${colors_range_etleft[key]}` }}></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      const colors_range_et_wbleft = [
        // "#ffffa0","#ffff78","#c0f766","#84ed48","#47de31","#58b660","#3cab80","#2595a9","#26659a","#203a77","#00ffff","#f6ffff","#c0c0c0"
        "#d6e4ff","#adc6ff","#85a5ff","#597ef7","#2f54eb","#2949cc","#1d39c4","#1d39c4","#10239e","#061178","#030852","#f0f5ff","#c7d1e6"
      ];
      const grades_et_wbleft = [
        "0 - 1",
        "1 - 2",
        "2 - 3",
        "3 - 4",
        " 4 - 5",
        "5 - 6",
        "6 - 7",
        " 7 - 8",
        "8 - 9",
        "9 - 10",
        "10",
      ];

      let img_wbleft = grades_et_wbleft.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i
              key={key}
              style={{ background: `${colors_range_et_wbleft[key]}` }}
            ></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      const colors_range_et_maileft= [
        // "#ffffa0","#ffff78","#c0f766","#84ed48","#47de31","#58b660","#3cab80","#2595a9","#26659a","#203a77","#00ffff","#f6ffff","#c0c0c0"
        "#c2523c", "#d66f2b", "#eda113","#f5ca0c",  "#ffff00" ,  "#7bed00","#00db00",  "#14ba5f" ,  "#20998f",  "#16678a", "#FFFFFF",
      ];
      const grades_et_maileft = [
        "00 - 10","10 - 20",
        "20 - 30",
        "30 - 40",
        "40 - 50",
        "50 - 60",
        "60 - 70",
        "70 - 80",
        "80 - 90",
        "90 - 100",
        "Cloud",
      ];

      let img_maileft = grades_et_maileft.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i
              key={key}
              style={{ background: `${colors_range_et_maileft[key]}` }}
            ></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });

      const colors_range_et_esileft = [
        // "#ffffa0","#ffff78","#c0f766","#84ed48","#47de31","#58b660","#3cab80","#2595a9","#26659a","#203a77","#00ffff","#f6ffff","#c0c0c0"
        //"#c2523c", "#d66f2b", "#eda113","#f5ca0c",  "#ffff00" ,  "#7bed00","#00db00",  "#14ba5f" ,  "#20998f",  "#16678a", "#FFFFFF",
        "#872626",   "#ad4f23",  "#d97c18" , "#f7a934", "#ffd175", "#ffffbf", "#b9b2bf", "#726eba" ,"#4045a8",  "#353191", "#27207a","#FFFFFF",
      ];
      const grades_et_esileft= [
        "-3.0 - -2.5",
        "-2.5 - -2.0" ,
        "-2.0 - -1.5" ,
        "-1.5 - -1.0",
        "-1.0 - -0.5" ,
        "-0.5 -  0.0",     
        "0.0 -  0.5" ,   
        "0.5 -  1.0" ,   
        "1.0 -  1.5" , 
        "1.5 -  2.0", 
        "2.0 -  2.5",
        "Cloud",
      ];

      let img_esileft = grades_et_esileft.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i
              key={key}
              style={{ background: `${colors_range_et_esileft[key]}` }}
            ></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      if (this.props.productselected !== prevProps.productselected ) {

      this.getLegendGraphic1( this.props.productselected).then((legend) => {
        console.log(layer,layer_type,"layertypeeeeeee",this.props.selected.split("-")[0]);
        //   this.props.setLegend(legend);
        if(this.props.productselected.split(" ")[0].toLowerCase()==="mai")
        {
         // console.log("maiiiiiiiiii")
        this.setState({
          legendleft: img_maileft,
        });
      }
      if(this.props.productselected.split(" ")[0].toLowerCase()==="esi")
        {
         // console.log("maiiiiiiiiii")

         console.log("maiiiiiiiiii  esi   left   ",this.props.productselected.split(" ")[0].toLowerCase())

        this.setState({
          legendleft: img_esileft,
        });
      }
        if (layer_type === "WB") {
          this.setState({
            legendleft: img_wbleft,
          });
        } 
        if(this.props.productselected.split(" ")[0].toLowerCase()==="et" ||this.props.productselected.split(" ")[0].toLowerCase()==="pet") {
         // console.log("maiiiiiii   e",imgleft)
          this.setState({
            legendleft: imgleft,
          });
        }
      });
    }
  }

    //----------------------
    if(this.props.productselectedR.split(" ")[0].toLowerCase()==="et" || this.props.productselectedR.split(" ")[0].toLowerCase()==="pet" || this.props.productselectedR.split(" ")[0].toLowerCase()==="mai" || this.props.productselectedR.split(" ")[0].toLowerCase()==="esi"  )
   {   
 
      const colors_range_etright = [
        "#ffffa0","#ffff78","#c0f766","#84ed48","#47de31","#58b660","#3cab80","#2595a9","#26659a","#203a77","#00ffff","#f6ffff","#c0c0c0"
        // "#d6e4ff","#adc6ff","#85a5ff","#597ef7","#2f54eb","#2949cc","#1d39c4","#1d39c4","#10239e","#061178","#030852","#f0f5ff","#c7d1e6"
      ];
      const grades_etright = [
        // "0 - 1",
        // "1 - 2",
        // "2 - 3",
        // "3 - 4",
        // " 4 - 5",
        // "5 - 6",
        // "6 - 7",
        // " 7 - 8",
        // "8 - 9",
        // "9 - 10",
        // "10",
        // "Cloud",
        // "No Data",
        "0.0-0.5","0.5-1.0","1.0-1.5","1.5-2.0","2.0-2.5","2.5-3.0","3.0-3.5","3.5-4.0","4.0-4.5","4.5-5.0",">5.0","Cloud","No Data"
      ];

      let imgright= grades_etright.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i key={key} style={{ background: `${colors_range_etright[key]}` }}></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      const colors_range_et_wbright = [
        // "#ffffa0","#ffff78","#c0f766","#84ed48","#47de31","#58b660","#3cab80","#2595a9","#26659a","#203a77","#00ffff","#f6ffff","#c0c0c0"
        "#d6e4ff","#adc6ff","#85a5ff","#597ef7","#2f54eb","#2949cc","#1d39c4","#1d39c4","#10239e","#061178","#030852","#f0f5ff","#c7d1e6"
      ];
      const grades_et_wbright = [
        "0 - 1",
        "1 - 2",
        "2 - 3",
        "3 - 4",
        " 4 - 5",
        "5 - 6",
        "6 - 7",
        " 7 - 8",
        "8 - 9",
        "9 - 10",
        "10",
      ];

      let img_wbright= grades_et_wbright.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i
              key={key}
              style={{ background: `${colors_range_et_wbright[key]}` }}
            ></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      const colors_range_et_mairight = [
        // "#ffffa0","#ffff78","#c0f766","#84ed48","#47de31","#58b660","#3cab80","#2595a9","#26659a","#203a77","#00ffff","#f6ffff","#c0c0c0"
        "#c2523c", "#d66f2b", "#eda113","#f5ca0c",  "#ffff00" ,  "#7bed00","#00db00",  "#14ba5f" ,  "#20998f",  "#16678a", "#FFFFFF",
      ];
      const grades_et_mairight = [
        "00 - 10","10 - 20",
        "20 - 30",
        "30 - 40",
        "40 - 50",
        "50 - 60",
        "60 - 70",
        "70 - 80",
        "80 - 90",
        "90 - 100",
        "Cloud",
      ];

      let img_mairight = grades_et_mairight.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i
              key={key}
              style={{ background: `${colors_range_et_mairight[key]}` }}
            ></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });

      const colors_range_et_esiright = [
              "#872626",   "#ad4f23",  "#d97c18" , "#f7a934", "#ffd175", "#ffffbf", "#b9b2bf", "#726eba" ,"#4045a8",  "#353191", "#27207a","#FFFFFF",
      ];
      const grades_et_esiright= [
        "-3.0 - -2.5",
        "-2.5 - -2.0" ,
        "-2.0 - -1.5" ,
        "-1.5 - -1.0",
        "-1.0 - -0.5" ,
        "-0.5 -  0.0",     
        "0.0 -  0.5" ,   
        "0.5 -  1.0" ,   
        "1.0 -  1.5" , 
        "1.5 -  2.0", 
        "2.0 -  2.5",
        "Cloud",
      ];

      let img_esiright = grades_et_esiright.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i
              key={key}
              style={{ background: `${colors_range_et_esiright[key]}` }}
            ></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      if (this.props.productselectedR !== prevProps.productselectedR ) {

      this.getLegendGraphic2( this.props.productselectedR).then((legend) => {
        //   this.props.setLegend(legend);
        if(this.props.productselectedR.split(" ")[0].toLowerCase()==="mai")
        {
          console.log("mainnnnnnnnnnnnnnnnnnnnnnnnn",this.props.productselectedR.split(" ")[0].toLowerCase())
        this.setState({
           legendright:img_mairight,
        });
      }
      

        if (layer_type === "WB") {
          this.setState({
            legendright: img_wbright,
          });
        } 
        
        if(this.props.productselectedR.split(" ")[0].toLowerCase()==="et"|| this.props.productselectedR.split(" ")[0].toLowerCase()==="pet") {
          console.log("mainnnnnnnnnnnnnnnnnnnnn   et,pet",this.props.productselectedR.split(" ")[0].toLowerCase())
          this.setState({
            legendright: imgright,
          });
        }

        if(this.props.productselectedR.split(" ")[0].toLowerCase()==="esi")
        {
          console.log("mainnnnnnnnnnnnnnnnnnnnnnnnnnnn  esi  right     ",this.props.productselectedR.split(" ")[0].toLowerCase())
        this.setState({
          legendright: img_esiright,
        });
      }
      });
    }
  }

 
  
      // Check if the layers props have changed
      if (prevProps.compareLeftWorkspace !== this.props.compareLeftWorkspace) {
        this.updateLayer(this.props.compareLeftWorkspace,this.props.compareLeftLayer);
      }
      if (prevProps.compareLeftLayer !== this.props.compareLeftLayer) {
        this.updateLayer(this.props.compareLeftWorkspace,this.props.compareLeftLayer);
      }

      if (prevProps.compareRightWorkspace !== this.props.compareRightWorkspace) {
        this.updateLayer(this.props.compareRightWorkspace,this.props.compareRightLayer);
      }
      if (prevProps.compareRightLayer !== this.props.compareRightLayer) {
        this.updateLayer(this.props.compareRightWorkspace,this.props.compareRightLayer);
      }
    }
  
  
    async getLegendGraphic1(layer) {
  
  
      let img_src = "a"

      return img_src;
    }
    async getLegendGraphic2(layer) {
  
  
      let img_src = "a"

      return img_src;
    }
    
    initializeMap() {
      //this.map = L.map(this.mapRef.current).setView(this.state.indiamapcenter,this.state.zoom,this.state.minZoom, this.state.maxZoom,  this.state.crs);

      this.map = L.map(this.mapRef.current, {
        crs: this.props.crs
      }).setView(this.props.center,  4,this.props.maxZoom, this.props.zoom);
      

      // this.map = L.map(this.mapRef.current).setView(this.state.indiamapcenter, this.state.zoom, {
      //   minZoom: this.state.minZoom,
      //   maxZoom: this.state.maxZoom,
      //   crs: this.props.crs
      // });
      
      //this.map = L.map(this.mapRef.current).setView({center:this.state.indiamapcenter},{zoom:this.state.zoom}, {minZoom:this.state.minZoom}  , {maxZoom:this.state.maxZoom},  {crs:this.props.crs});
      //L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map);

    
      //this.state.legend.addTo(this.map);
    // url = urls.bhuvan_map;
    // layers = urls.map_layer;
    

     this.open=L.tileLayer.wms('https://bhuvan-vec1.nrsc.gov.in/bhuvan/gwc/service/wms', {
        layers:'india3',
        format: 'image/png',
        transparent: true,
        version: '1.1.1',
      
        tileSize: 256,

        
        
      }).addTo(this.map)
      this.satelliteLayer = L.tileLayer.wms('https://bhuvan-ras2.nrsc.gov.in/tilecache/tilecache.py', {
        layers:'bhuvan_img',
        format: 'image/png',
        transparent: true,
      

        
      })

  
      // Add OpenStreetMap layer by default
    
  
      
      // const boundary = L.geoJSON(this.props.boundary, {
      //   style: {
      //     color: 'black', // Change color to whatever you desire
      //     weight: 1 ,
      //     fillOpacity:0// Change the border weight if needed
      //   },
      //   onEachFeature: function (feature, layer) {
      //     if (feature.properties && feature.properties.popupContent) {
      //       layer.bindPopup(feature.properties.popupContent);
      //     }
      //   }
      // }).addTo(this.map);
    
       this.osmLayer =  L.tileLayer.wms(`https://bhuvan.nrsc.gov.in/nhpgs/${this.props.compareLeftWorkspace}/wms`, {
        layers:`${this.props.compareLeftLayer}`,
        format: 'image/png',
        transparent: true,
        version: '1.1.1',
        maxZoom: 15,
        minZoom: 3,
        tileSize: 256,
        crs: L.CRS.EPSG4326, // Specify the coordinate reference system
        
      })

      this.stamenLayer = L.tileLayer.wms(`https://bhuvan.nrsc.gov.in/nhpgs/${this.props.compareRightWorkspace}/wms`, {
        layers:`${this.props.compareRightLayer}`,
        format: 'image/png',
        transparent: true,
        version: '1.1.1',
        maxZoom: 15,
        minZoom: 3,
        tileSize: 256,
        crs: L.CRS.EPSG4326, // Specify the coordinate reference system
      
    })



       this.osmLayer.addTo(this.map)
      this.stamenLayer.addTo(this.map);
      // var stamenLayer = L.tileLayer(
      //   "https://stamen-tiles-{s}.a.ssl.fastly.net/toner/{z}/{x}/{y}{r}.png", {
      //     attribution: '&copy; <a href="http://maps.stamen.com/toner/">Stamen</a> contributors',
      //     minZoom: 1,
      //     maxZoom: 16
      //   }
      // ).addTo(map);
     
      this.sideBySideControl= L.control.sideBySide( this.osmLayer,this.stamenLayer).addTo(this.map);
   
    }

    addPanelTitles() {
      // Define left and right titles based on props
      let lefttitle = "Left Panel";
      let righttitle = "Right Panel";
  
      // For left title
      if (this.props.timestampselected === "Fortnightly") {

        if (this.props.compare_fn_selectedMonth!==null && this.props.compare_fn_selectedFN!==null && this.props.compare_fn_selectedYear!==null )
        {
          lefttitle = `${this.props.compare_fn_selectedMonth} ${this.props.compare_fn_selectedFN} ${this.props.compare_fn_selectedYear}`;
        }
      } else if (this.props.timestampselected === "Monthly") {
        if(this.props.compare_mn_selectedMonth!==null && this.props.compare_mn_selectedYear!== null){
          lefttitle = `${this.props.compare_mn_selectedMonth} ${this.props.compare_mn_selectedYear}`;
        }
      }
  
      // For right title
      if (this.props.timestampselectedR === "Fortnightly") {
        console.log("titleeeeeeeee",this.props.compare_fn_selectedMonthR,this.props.compare_fn_selectedFNR,this.props.compare_fn_selectedYearR)
        if (this.props.compare_fn_selectedMonthR!==null && this.props.compare_fn_selectedFNR!==null && this.props.compare_fn_selectedYearR!==null )
        {
          righttitle = `${this.props.compare_fn_selectedMonthR} ${this.props.compare_fn_selectedFNR} ${this.props.compare_fn_selectedYearR}`;
        }
      } else if (this.props.timestampselectedR === "Monthly") {
        if(this.props.compare_mn_selectedMonthR!==null && this.props.compare_mn_selectedYearR!== null){
          righttitle = `${this.props.compare_mn_selectedMonthR} ${this.props.compare_mn_selectedYearR}`;
        }
      }
      // Create the left title control only once (on component mount)
  if (!this.leftTitle) {
    this.leftTitle = L.control({ position: 'topleft' });
    this.leftTitle.onAdd = () => {
      const div = L.DomUtil.create('div', 'leaflet-control leaflet-bar leaflet-left-title');
      div.innerHTML = `<div class="panel-title">${lefttitle}</div>`;
      return div;
    };
    this.leftTitle.addTo(this.map);
  } else {
    // If left title exists, update its content
    const leftTitleDiv = this.leftTitle.getContainer();
    const titleElement = leftTitleDiv.querySelector('.panel-title');
    if (titleElement) {
      titleElement.innerHTML = lefttitle;
    }
  }

  // Create the right title control only once (on component mount)
  if (!this.rightTitle) {
    this.rightTitle = L.control({ position: 'topright' });
    this.rightTitle.onAdd = () => {
      const div = L.DomUtil.create('div', 'leaflet-control leaflet-bar leaflet-right-title');
      div.innerHTML = `<div class="panel-title">${righttitle}</div>`;
      return div;
    };
    this.rightTitle.addTo(this.map);
  } else {
    // If right title exists, update its content
    const rightTitleDiv = this.rightTitle.getContainer();
    const titleElement = rightTitleDiv.querySelector('.panel-title');
    if (titleElement) {
      titleElement.innerHTML = righttitle;
    }
  }
}
    handleLayerChange = (selectedLayer) => {
      // Update selectedLayer state and update layers accordingly
      this.setState({ selectedLayer }, () => {
        if (selectedLayer === "osm") {
          this.map.removeLayer(this.satelliteLayer);
          this.osmLayer =  L.tileLayer.wms(`https://bhuvan.nrsc.gov.in/nhpgs/${this.props.compareLeftWorkspace}/wms`, {
            layers:`${this.props.compareLeftLayer}`,
            format: 'image/png',
            transparent: true,
            version: '1.1.1',
            maxZoom: 15,
            minZoom: 3,
            tileSize: 256,
            crs: L.CRS.EPSG4326, // Specify the coordinate reference system
            
          })
    
           this.stamenLayer =  L.tileLayer.wms(`https://bhuvan.nrsc.gov.in/nhpgs/${this.props.compareRightWorkspace}/wms`, {
            layers:`${this.props.compareRightLayer}`,
            format: 'image/png',
            transparent: true,
            version: '1.1.1',
            maxZoom: 15,
            minZoom: 3,
            tileSize: 256,
            crs: L.CRS.EPSG4326, // Specify the coordinate reference system
          
        })
    
    
    
           this.osmLayer.addTo(this.map)
          this.stamenLayer.addTo(this.map);
          this.sideBySideControl.setLeftLayers(this.osmLayer);
          this.sideBySideControl.setRightLayers(this.stamenLayer);



          this.open.addTo(this.map);
        } else {
          this.osmLayer =  L.tileLayer.wms(`https://bhuvan.nrsc.gov.in/nhpgs/${this.props.compareLeftWorkspace}/wms`, {
            layers:`${this.props.compareLeftLayer}`,
            format: 'image/png',
            transparent: true,
            version: '1.1.1',
            maxZoom: 15,
            minZoom: 3,
            tileSize: 256,
            crs: L.CRS.EPSG4326, // Specify the coordinate reference system
            
          })
    
           this.stamenLayer =  L.tileLayer.wms(`https://bhuvan.nrsc.gov.in/nhpgs/${this.props.compareRightWorkspace}/wms`, {
            layers:`${this.props.compareRightLayer}`,
            format: 'image/png',
            transparent: true,
            version: '1.1.1',
            maxZoom: 15,
            minZoom: 3,
            tileSize: 256,
            crs: L.CRS.EPSG4326, // Specify the coordinate reference system
          
        })
    
    
    
           this.osmLayer.addTo(this.map)
          this.stamenLayer.addTo(this.map);
          this.sideBySideControl.setLeftLayers(this.osmLayer);
          this.sideBySideControl.setRightLayers(this.stamenLayer);
          this.map.removeLayer(this.open);
          this.satelliteLayer.addTo(this.map);
        }
      });
    };
    updateLayer(compareLeftWorkspace,compareLeftLayer)
    {
      try {
      if (this.osmLayer  ) {
        this.map.removeLayer(this.osmLayer);
      }
      if (this.stamenLayer  ) {
        this.map.removeLayer(this.stamenLayer);
      }
      // if ( !this.props.stopVisualisationLeft ) {
      //   this.map.removeLayer(this.osmLayer);
      //   this.osmLayer = null; // Reset osmLayer reference

      // }
      this.osmLayer =  L.tileLayer.wms(`https://bhuvan.nrsc.gov.in/nhpgs/${this.props.compareLeftWorkspace}/wms`, {
        layers:`${this.props.compareLeftLayer}`,
        format: 'image/png',
        transparent: true,
        version: '1.1.1',
        maxZoom: 15,
        minZoom: 3,
        tileSize: 256,
        crs: L.CRS.EPSG4326, // Specify the coordinate reference system
        
      })

       this.stamenLayer =  L.tileLayer.wms(`https://bhuvan.nrsc.gov.in/nhpgs/${this.props.compareRightWorkspace}/wms`, {
        layers:`${this.props.compareRightLayer}`,
        format: 'image/png',
        transparent: true,
        version: '1.1.1',
        maxZoom: 15,
        minZoom: 3,
        tileSize: 256,
        crs: L.CRS.EPSG4326, // Specify the coordinate reference system
      
    })



       this.osmLayer.addTo(this.map)
      this.stamenLayer.addTo(this.map);
      this.sideBySideControl.setLeftLayers(this.osmLayer);
      this.sideBySideControl.setRightLayers(this.stamenLayer);
    } catch (error) {
      console.error("Error updating layers:", error);
      window.alert("Error: " + error.message);
    }
  }
  

    render() {
  

      console.log("this is boundary in leaflet compareproduct",this.props.productselected,this.props.productselectedR,this.props.productselected.split(" ")[0].toLowerCase,this.props.productselectedR.split(" ")[0].toLowerCase)
      //console.log("this is boundary in leaflet compare",this.props.legend,"=======",this.state.legend,"===",this.props.selected.split("-")[0]) 
     let product1,product2,legendleft;

     
     

     if(this.props.productselected.split(" ")[0].toLowerCase()==="mai")
      {
        product1="Moisture Adequacy Index (%)"

      }

      if( this.props.productselected.split(" ")[0].toLowerCase()==="esi")
      {
        product1="Evaporative Stress Index"
      }
      if(this.props.productselected.split(" ")[0].toLowerCase()==="et"|| this.props.productselected.split(" ")[0].toLowerCase()==="pet")
      {
        product1="Evapotranspiration (mm/day)"
       // legendleft=this.state.legendleft

      }
      if(this.props.productselectedR.split(" ")[0].toLowerCase()==="mai")
      {
        product2="Moisture Adequacy Index (%)"

      }

      if( this.props.productselectedR.split(" ")[0].toLowerCase()==="esi")
      {
        product2="Evaporative Stress Index"
      }
      if(this.props.productselectedR.split(" ")[0].toLowerCase()==="et"|| this.props.productselectedR.split(" ")[0].toLowerCase()==="pet")
      {
        product2="Evapotranspiration (mm/day)"

      }
    console.log("baselayers in compare",this.state.baselayers)
  
      
      return (
        <div id="map" ref={this.mapRef}>
        <div className="compareButton" style={{ marginTop: "7rem" }}>
          <Button
            onClick={this.props.handleAnimationChange}
            secondary
            style={{ backgroundColor: colors.sidebar, zIndex: 1000 }}
            attached="right"
            compact
            size="mini"
          >
            <FontAwesomeIcon icon="th-list" size="sm" />
          </Button>
        </div>
      
        < div className="containerCompare">
          <div style={{ background: colors["final_side"], zIndex: 1100,marginTop:"-100px" }}>
            <Menu.Item
              as="div"
              onClick={this.handlebaselayerchange}
              style={{
                textAlign: "center",
               // marginLeft: `5px`,
                cursor: "pointer",
              }}
            >
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    width: "80%",
                    color: colors["white"],
                    fontSize: "small",
                    cursor: "default",
                  }}
                >
                  Base Layers
                </div>
                <div
                  style={{
                    textAlign: "right",
                    width: "2%",
                    marginRight: "30px",
                  }}
                >
                  {this.state.baselayers ? (
                    <FontAwesomeIcon icon="angle-down" />
                  ) : (
                    <FontAwesomeIcon icon="angle-right" />
                  )}
                </div>
              </div>
            </Menu.Item>
          </div>
      
      
           {this.state.baselayers ? (
            <label>
                  <div>
                
                  <input
                    type="radio"
                    value="osm"
                    checked={this.state.selectedLayer === "osm"}
                    onChange={() => this.handleLayerChange("osm")}
                  />
                  Map <br/>
                  <input
                    type="radio"
                    value="satellite"
                    checked={this.state.selectedLayer === "satellite"}
                    onChange={() => this.handleLayerChange("satellite")}
                  />
                  Satellite
              </div>
              </label>
            ):null}
              </div>
      





        {/* Other map elements */}
        <div className="legend-container">

        {
          this.props.stopVisualisationLeft && (
          <div class="left-legend">
          <div className="legend-items ">
          <b> {product1} </b>
          
          <div className="info legend">
            {this.state.legendleft}
        </div>
        </div>
        </div>

          )
        }
          
          {  this.props.stopVisualisationRight && (

            <div class="right-legend">
            <div className="legend-items1 ">
            <b> {product2} </b>
              <div className="info legend">
                {this.state.legendright}
              
              </div>
              </div>
              </div>
          )}
       
          </div>
      
      </div>


        
      );
    }
  }
  

export default LeafletCompare;



